import { useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import api from "../services/api";
import { useNavigate } from "react-router-dom";
import "../styles/listaTorneos.css";

export default function ListaTorneos() {
  const { token } = useAuth();
  const navigate = useNavigate();
  const [torneos, setTorneos] = useState([]);
  const [error, setError] = useState("");
  const [grupoSeleccionado, setGrupoSeleccionado] = useState("LIBRES"); // Grupo seleccionado por defecto

  useEffect(() => {
    // Obtener la lista de torneos vigentes
    api.get("/torneos", {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => setTorneos(res.data))
      .catch((err) => setError("Error al cargar los torneos"));
  }, [token]);

  // Filtrar torneos por género
  const torneosLibres = torneos.filter((torneo) => torneo.genero === "Libres");
  const torneosDamas = torneos.filter((torneo) => torneo.genero === "Damas");

  // Obtener los torneos del grupo seleccionado
  const torneosMostrar =
    grupoSeleccionado === "LIBRES" ? torneosLibres : torneosDamas;

  if (error) {
    return <p className="error-message">{error}</p>;
  }

  return (
    <div className="lista-torneos-container">
      <h2>Torneos Vigentes</h2>
      <div className="botones-grupo">
        <button
          className={grupoSeleccionado === "LIBRES" ? "activo" : ""}
          onClick={() => setGrupoSeleccionado("LIBRES")}
        >
          LIBRES
        </button>
        <button
          className={grupoSeleccionado === "DAMAS" ? "activo" : ""}
          onClick={() => setGrupoSeleccionado("DAMAS")}
        >
          DAMAS
        </button>
      </div>
      {torneosMostrar.length === 0 ? (
        <p>No hay torneos disponibles en este grupo.</p>
      ) : (
        <table className="tabla-torneos">
          <thead>
            <tr>
              <th>Nombre</th>
              <th>Categoría</th>
              <th>Fecha Inicio</th>
              <th>Fecha Fin</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {torneosMostrar.map((torneo) => (
              <tr key={torneo.id}>
                <td>{torneo.nombre}</td>
                <td>{torneo.categoria}</td>
                <td>{new Date(torneo.fecha_inicio).toLocaleDateString()}</td>
                <td>{new Date(torneo.fecha_fin).toLocaleDateString()}</td>
                <td>
                  <button
                    onClick={() => navigate(`/torneos/${torneo.id}/inscripcion`)}
                  >
                    Inscribirse
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}